@let transition = $transition();
<unity-dialog-shared [title]="`${transition.name}?`" (closeEvent)="onClose()">
  @let formGroup = $formGroup();
  @let formId = 'dialogFormId';
  <ng-content dialog-body>
    <form [id]="formId" [formGroup]="formGroup" (ngSubmit)="onSave()">
      <p>Please explain briefly why you are making this change.</p>
      <unity-textarea-control
        class="full-width-textarea"
        description="Provide context or your reason for this change"
        [control]="formGroup.controls.comment"
        [displayName]="transition.is_comment_required ? 'Comment' : 'Comment (Optional)'" />

      @if (transition.is_date_overrideable) {
        <unity-selector-date-control
          class="full-width-textarea"
          description="Provide when this change happened"
          displayName="Date"
          [control]="formGroup.controls.date" />
      }
    </form>
  </ng-content>
  <ng-content ngProjectAs="[dialog-actions]">
    <button kendoButton type="button" [formGroup]="formGroup" (click)="onClose()">No, I changed my mind</button>
    <button kendoButton themeColor="secondary" type="submit" [attr.form]="formId">Yes, {{ transition.name.toLocaleLowerCase() }}</button>
  </ng-content>
</unity-dialog-shared>
